import { useState } from 'react';
import { faqData } from '@/mocks/comics';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于奇漫屋，你可能想知道的事情
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-45' : ''
                }`}>
                  <i className="ri-add-line"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <SchemaOrg
        type="FAQPage"
        faqItems={faqData.map(f => ({ question: f.question, answer: f.answer }))}
      />
    </section>
  );
}